export default "__VITE_ASSET__BjiRYUnq__"